import classNames from "classnames";
import { Button } from "components/DesignSystem/Button/Button";
import { Slider } from "components/DesignSystem/Slider/Slider";
import Tab from "components/DesignSystem/Tab/Tab";
import DashboardContainer from "components/dashboard/DashboardContainer";
import { ArrowLeft } from "components/icons/ArrowLeft";
import { Cross } from "components/icons/Cross";
import { usePaginatedMessages } from "hooks/usePaginatedMessages";
import { useDispatch, useSelector } from "react-redux";
import { closeTicketSlider } from "store/slices/channelInfoSlider";
import { RootState } from "store/store";
import { useChannelStateContext, useChatContext } from "stream-chat-react";
import { TicketList } from "./TicketList";
import { useState } from "react";
import { useGetUnresolvedTicketMessageIdsQuery } from "store/apis/chat";
import Loader from "components/DesignSystem/Loader/loader";

export const ChatTicketSlider = ({ block = false }: { block?: boolean }) => {
  const { channel } = useChannelStateContext();
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState<"OPEN" | "RESOLVED">("OPEN");
  const sliderOpen = useSelector(
    (store: RootState) => store.channelInfoSlider.showTicketSlider
  );

  const { data, isLoading, isFetching } = useGetUnresolvedTicketMessageIdsQuery(
    {
      channelUrl: channel?.id!,
      resolved_status: selectedTab === "RESOLVED",
    },
    { skip: !channel?.id }
  );

  const onOutslideSliderClick = () => {
    if (sliderOpen) {
      dispatch(closeTicketSlider());
    }
  };

  return (
    <Slider
      open={sliderOpen}
      className={classNames(
        "t-absolute !t-p-0 t-shadow-slider !t-h-full t-z-10",
        {
          "t-w-full": block,
          "t-w-[360px] sm:t-w-full": !block,
        }
      )}
      position="right"
      width={360}
    >
      <Tab.Root defaultValue="OPEN" className="t-h-full">
        <DashboardContainer className="t-h-full">
          <DashboardContainer.Header>
            <div className="t-py-3 t-pr-4 t-pl-5 t-flex t-justify-between t-items-center ">
              <div className="t-flex t-gap-2 t-items-center">
                <Button
                  customType="ghost_icon"
                  size="small"
                  onClick={onOutslideSliderClick}
                >
                  <span className="t-text-text-30">
                    <ArrowLeft size="16" />
                  </span>
                </Button>
                <span className="t-text-subtitle">Tickets</span>
              </div>
              <Button
                customType="ghost_icon"
                size="small"
                onClick={onOutslideSliderClick}
              >
                <Cross />
              </Button>
            </div>

            <div className="t-flex t-flex-col t-gap-4 t-px-5 t-pt-0 t-border-b t-border-0 t-border-solid t-border-i-neutral-10">
              <Tab.List className="t-flex t-gap-2">
                <Tab.Trigger
                  value="OPEN"
                  onClick={() => setSelectedTab("OPEN")}
                >
                  <span className="t-text-body-sm">Open</span>
                </Tab.Trigger>
                <Tab.Trigger
                  value="RESOLVED"
                  onClick={() => setSelectedTab("RESOLVED")}
                >
                  <span className="t-text-body-sm">Resolved</span>
                </Tab.Trigger>
              </Tab.List>
            </div>
          </DashboardContainer.Header>
          <DashboardContainer.Content
            className="t-p-5 t-pt-4"
            id="media-scroll"
          >
            <div className="t-flex t-flex-col t-gap-4 t-h-full">
              {isLoading || isFetching ? (
                <div className="t-h-full t-flex t-w-full t-justify-center t-items-center">
                  <Loader size="small" />
                </div>
              ) : (
                <div className="t-h-full">
                  <Tab.Content value="OPEN" className="t-h-full">
                    <TicketList
                      ticketMessages={data?.ticket_messages || []}
                      channelUrl={channel.id!}
                      emptyStateText="No tickets pending"
                    />
                  </Tab.Content>
                  <Tab.Content value="RESOLVED" className="t-h-full">
                    <TicketList
                      ticketMessages={data?.ticket_messages || []}
                      resolved
                      channelUrl={channel.id!}
                      emptyStateText="No tickets resolved"
                    />
                  </Tab.Content>
                </div>
              )}
            </div>
          </DashboardContainer.Content>
        </DashboardContainer>
      </Tab.Root>
    </Slider>
  );
};
